<template>
	<div class="sm:py-5 sm:px-6 sm:shadow sm:rounded transition duration-500 ease-in-out bg-gray-900 col-span-1 col-end-3">
		<vue-agile :autoplay="false" :speed="2000">
			<div>
				<div class="flex flex-col items-center text-white text-2xl p-8">
					<span class="mb-4">Video Tour</span>
					<span class="mb-4 text-base">Welcome to Racing Stars! Thanks for signing up. Checkout our quick video tour.</span>
					<vue-player-video :src="asset('media/million-pound-challenge.mp4')" />
					<a :href="route('dashboard')" class="rounded bg-racing-stars-yellow py-2 px-4 text-gray-900 mt-4 text-base">Play Now!</a>
				</div>
			</div>
		</vue-agile>
	</div>
</template>

<script>
	import { VueAgile } from 'vue-agile'
	import VuePlayerVideo from 'vue3-player-video'

	export default {
		setup(props) {



		},

		components: {
			VueAgile,
			VuePlayerVideo,
		}
	}
</script>